'use client';
import { CalendarOutlined, CustomerServiceOutlined, GiftOutlined } from '@ant-design/icons';
import { useTranslation } from '@root/src/i18n/client';
import { fetchBanner5 } from '@root/src/services/client/banner';
import Image from '@components/common/ImageFallback';
import { useEffect, useState } from 'react';

const GiftContent = () => {
  const [banners, setBanners] = useState(null);
  useEffect(() => {
    // Gọi hàm fetchBanner5
    const fetchData = async () => {
      try {
        const data = await fetchBanner5();
        setBanners(data); // Lưu dữ liệu vào state
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    };

    fetchData();
  }, []);

  const { t } = useTranslation('common');
  return (
    <div className="max-w-7xl">
      {/* Hero Section */}
      <div className="relative bg-white mt-9 md:mt-0 shadow-lg overflow-hidden mb-4 md:mb-8">
        <Image
          src={banners?.imagePath || '/images/contact.webp'}
          alt="Gifts"
          width={1200}
          height={300}
          sizes="(max-width: 600px) 50vw, (max-width: 1200px) 50vw, 40vw"
          className="w-full h-auto object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center ml-[180px] md:ml-[600px]">
          <h2 className="text-white text-xs md:text-2xl font-light">
            {t('Discover the Perfect Gifts')}
          </h2>
        </div>
      </div>

      <div className="items-left">
        <div className="max-w-4xl mx-auto py-8 px-4 lg:py-12 lg:px-8">
          {/* Title */}
          <h2 className="text-xs md:text-lg font-semibold text-gray-900 mb-6 text-left">
            {t('Our Gift Collections')}
          </h2>
          <div className="">
            <div className="flex items-left gap-4 py-3 px-6 rounded-lg hover:bg-gray-100 transition">
              {/* Icon */}
              <div className="w-10 h-10 flex justify-center items-center text-black">
                <GiftOutlined />
              </div>

              {/* Title */}
              <h3 className="text-xs md:text-[13px] text-gray-800 mt-3">
                {t('Luxury Gift Sets')}
              </h3>
            </div>
            <div className="flex items-left gap-4 py-3 px-6 rounded-lg hover:bg-gray-100 transition">
              {/* Icon */}
              <div className="w-10 h-10 flex justify-center items-center text-black">
                <CalendarOutlined />
              </div>

              {/* Title */}
              <h3 className="text-xs md:text-[13px] text-gray-800 mt-3">
                {t('Special Occasion Gifts')}
              </h3>
            </div>
            <div className="flex items-left gap-4 py-3 px-6 rounded-lg hover:bg-gray-100 transition">
              {/* Icon */}
              <div className="w-10 h-10 flex justify-center items-center text-black">
                <CustomerServiceOutlined />
              </div>

              {/* Title */}
              <h3 className="text-xs md:text-[13px] text-gray-800 mt-3">
                {t('Personalized Gifts')}
              </h3>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
};

export default GiftContent;
